import * as actionTypes from '../action';
import axios from "axios";
import { logout } from "../../components/common/FirebaseSupervisor";

let SERVER_API_URL = process.env.REACT_APP_SERVER_URL_API;
let VFASP_ID = process.env.REACT_APP_VFASP_CODE;
let token = '';
let adminId = '';

export const client = (token = null) => {
    const defaultOptions = {
        headers: {
            Authorization: token ? `Bearer ${token}` : '',
        },
    };

    return {
        get: (url, options = {}) => axios.get(url, { ...defaultOptions, ...options }),
        post: (url, data, options = {}) => axios.post(url, data, { ...defaultOptions, ...options }),
        put: (url, data, options = {}) => axios.put(url, data, { ...defaultOptions, ...options }),
        delete: (url, options = {}) => axios.delete(url, { ...defaultOptions, ...options }),
    };
};

export const isValidSession = async (dispatch) => {
    token = localStorage.getItem("supervisortoken");
    adminId = localStorage.getItem("supervisorid");
    let loginFlag = localStorage.getItem("isSupervisorLogin");
    if (adminId === null || token === null || loginFlag === null || !token || !adminId || !loginFlag) {
        logout();
        dispatch({ type: actionTypes.SUPERVISOR_SESSION_ERROR, payload: true });
        return false;
    }
    return true;
};

export const checkValidSession = () => {
    token = localStorage.getItem("supervisortoken");
    adminId = localStorage.getItem("supervisorid");
    let loginFlag = localStorage.getItem("isSupervisorLogin");
    if (adminId === null || token === null || loginFlag === null || !token || !adminId || !loginFlag) {
        console.log("checkValidSession: Invalid Session");
        logout();
        return false;
    }
    return true;
};

export const getToken = () => {
    return token;
};

export const getAdminID = () => {
    return adminId;
};

export const getVFASOList = () => {
    let arVFASP = [];
    let sVFASP = localStorage.getItem("VFASPList");
    if (sVFASP) {
        arVFASP = JSON.parse(sVFASP);
    }
    return arVFASP;
};

export const getQueryVariable = (searchString, variable) => {
    var query = searchString.substring(1);
    var vars = query.split("&");
    for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split("=");
        if (pair[0] === variable) {
            return pair[1];
        }
    }
    return ("");
};

export const formatDate = (dtInput) => {
    try {
        var d = new Date(dtInput);
        if (isNaN(d)) {
            return null;
        }
        var sMonth = '' + (d.getMonth() + 1);
        var sDay = '' + d.getDate();
        var nYear = d.getFullYear();

        if (sMonth.length < 2) {
            sMonth = '0' + sMonth;
        }
        if (sDay.length < 2) {
            sDay = '0' + sDay;
        }

        return [nYear, sMonth, sDay].join('-');
    } catch (error) {
        console.log(error);
        return null;
    }
};

export const getLoginSupervisorAccessRights = async () => {
    if (!checkValidSession()) {
        return;
    }
    try {
        let accessResponse = await client(token).post(`${SERVER_API_URL}/accessrights/findall`, {
            VfaspID: process.env.REACT_APP_VFASP_CODE,
            AdminID: adminId,
            SearchAdminID: adminId
        });
        if (accessResponse.status !== 200) {
            alert("Server Error");
            return 0;
        }
        let accessRightsMap = {};
        if (accessResponse.data.length > 0) {
            let index = 0;
            for (index = 0; index < accessResponse.data.length; index++) {
                accessRightsMap[accessResponse.data[index].PageID] = accessResponse.data[index];
            }
        }
        localStorage.setItem("SupervisorAccessRights", JSON.stringify(accessRightsMap));
    } catch (error) {
        console.log(error);
        logout();
    }
};

export const isLoginSupervisorAccessRightsLoaded = () => {
    try {
        let sAccessRights = localStorage.getItem("SupervisorAccessRights");
        if (sAccessRights) {
            let allAccessRights = JSON.parse(sAccessRights);
            if (allAccessRights) {
                return true;
            } else {
                return false;
            }
        } else {
            return false;
        }
    } catch (error) {
        console.log(error);
        return false;
    }
};

export const getAccessRightsForPageID = (pageId) => {
    try {
        let sAccessRights = localStorage.getItem("SupervisorAccessRights");
        if (sAccessRights) {
            let allAccessRights = JSON.parse(sAccessRights);
            let pageAccessRights = {};
            if (allAccessRights[pageId]) {
                pageAccessRights = allAccessRights[pageId];
            }
            return pageAccessRights;
        } else {
            return {};
        }
    } catch (error) {
        console.log(error);
        return {};
    }
};

export const isValidPassword = (sPassword, arCommonWords) => {
    const regexPassword = /^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z]).{8,}$/;
    let index = 0;

    try {
        if (sPassword.length < 10 || !regexPassword.test(sPassword)) {
            return false;
        }

        if (!arCommonWords) {
            arCommonWords = [];
        }
        arCommonWords.push('Password');
        arCommonWords.push('Pwd');
        arCommonWords.push('Progress');
        arCommonWords.push('Guest');
        arCommonWords.push('Admin');
        arCommonWords.push('System');
        arCommonWords.push('SysAdmin');
        arCommonWords.push('Supervisor');
        arCommonWords.push('User');
        let sPasswordLowerCase = sPassword.toLowerCase();
        for (index = 0; index < arCommonWords.length; index++) {
            let sCheckStr = arCommonWords[index].toLowerCase();
            if (sPasswordLowerCase.indexOf(sCheckStr) >= 0) {
                return false;
            }
        }

        return true;
    } catch (err) {
        console.error(err);
        return false;
    }
};

export const actionGetSupervisorProfile = () => async (dispatch, getState) => {
    dispatch({ type: actionTypes.SUPERVISOR_DATA_LOADING, payload: true });
    try {
        token = localStorage.getItem("supervisortoken");
        adminId = localStorage.getItem("supervisorid");
        if (adminId === null || token === null || !token || !adminId) {
            logout();
            dispatch({ type: actionTypes.SUPERVISOR_SESSION_ERROR, payload: true });
            return;
        }

        let result = await client(token).post(`${SERVER_API_URL}/supervisor/find`, {
            VfaspID: VFASP_ID,
            AdminID: adminId
        });
        dispatch({ type: actionTypes.SUPERVISOR_DATA_LOADING, payload: false });
        if (parseInt(result.status) === 200) {
            dispatch({ type: actionTypes.SUPERVISOR_DATA_SUCCESS, payload: result.data });
        } else if (parseInt(result.status) === 403) {
            logout();
        } else {
            console.log(result, 8);
            dispatch({ type: actionTypes.DATALOAD_ERROR, payload: result });
        }
    } catch (error) {
        console.log(error, 5);
        logout();
    }
};

export const actionGetVFASPsForSearch = () => async (dispatch, getState) => {
    try {
        if (await isValidSession(dispatch) === false) {
            return;
        }

        let result = await client(token).post(`${SERVER_API_URL}/vfaspclient/find/all`, {
            VfaspID: VFASP_ID,
            AdminID: adminId
        });
        if (parseInt(result.status) === 200) {
            localStorage.setItem("VFASPList", JSON.stringify(result.data));
        } else if (parseInt(result.status) === 403) {
            logout();
        } else {
            console.log(result, 8);
            dispatch({ type: actionTypes.DATALOAD_ERROR, payload: result });
        }
    } catch (error) {
        console.log(error, 5);
        logout();
    }
};

export const actionGetExchangeRate = () => async (dispatch, getState) => {
    dispatch({ type: actionTypes.EXCHANGERATE_DATA_LOADING, payload: true });
    try {
        if (await isValidSession(dispatch) === false) {
            return;
        }

        let result = await client(token).post(`${SERVER_API_URL}/exchangerate/find`, {
            VfaspID: VFASP_ID,
            AdminID: adminId
        });
        dispatch({ type: actionTypes.EXCHANGERATE_DATA_LOADING, payload: false });
        if (parseInt(result.status) === 200) {
            dispatch({ type: actionTypes.EXCHANGERATE_DATA_SUCCESS, payload: result.data });
        } else if (parseInt(result.status) === 403) {
            logout();
        } else {
            console.log(result, 8);
            dispatch({ type: actionTypes.DATALOAD_ERROR, payload: result });
        }
    } catch (error) {
        console.log(error, 5);
        alert("System Error");
    }
};

export const actionGetSupervisorList = (requestBody) => async (dispatch, getState) => {
    dispatch({ type: actionTypes.SUPERVISORLIST_DATA_LOADING, payload: true });
    try {
        if (await isValidSession(dispatch) === false) {
            return;
        }

        requestBody.VfaspID = VFASP_ID;
        requestBody.AdminID = adminId;
        let result = await client(token).post(`${SERVER_API_URL}/supervisor/findall`, requestBody);
        dispatch({ type: actionTypes.SUPERVISORLIST_DATA_LOADING, payload: false });
        if (parseInt(result.status) === 200) {
            dispatch({ type: actionTypes.SUPERVISORLIST_DATA_SUCCESS, payload: result.data });
        } else if (parseInt(result.status) === 403) {
            logout();
        } else {
            console.log(result, 8);
            dispatch({ type: actionTypes.DATALOAD_ERROR, payload: result });
        }
    } catch (error) {
        console.log(error, 5);
        alert("System Error");
    }
};

export const actionGetSupervisorListForAccessRights = (requestBody) => async (dispatch, getState) => {
    dispatch({ type: actionTypes.SUPERVISORLIST_DATA_LOADING, payload: true });
    try {
        if (await isValidSession(dispatch) === false) {
            return;
        }

        requestBody.SearchAdminRole = 'Admin';
        requestBody.VfaspID = VFASP_ID;
        requestBody.AdminID = adminId;
        let result = await client(token).post(`${SERVER_API_URL}/supervisor/findall`, requestBody);
        dispatch({ type: actionTypes.SUPERVISORLIST_DATA_LOADING, payload: false });
        if (parseInt(result.status) === 200) {
            dispatch({ type: actionTypes.SUPERVISORLIST_DATA_SUCCESS, payload: result.data });
        } else if (parseInt(result.status) === 403) {
            logout();
        } else {
            console.log(result, 8);
            dispatch({ type: actionTypes.DATALOAD_ERROR, payload: result });
        }
    } catch (error) {
        console.log(error, 5);
        alert("System Error");
    }
};

export const actionGetVFASPClientList = (requestBody) => async (dispatch, getState) => {
    dispatch({ type: actionTypes.CLIENTLIST_DATA_LOADING, payload: true });
    try {
        if (await isValidSession(dispatch) === false) {
            return;
        }

        requestBody.VfaspID = VFASP_ID;
        requestBody.AdminID = adminId;
        let result = await client(token).post(`${SERVER_API_URL}/vfaspclient/findall`, requestBody);
        dispatch({ type: actionTypes.CLIENTLIST_DATA_LOADING, payload: false });
        if (parseInt(result.status) === 200) {
            dispatch({ type: actionTypes.CLIENTLIST_DATA_SUCCESS, payload: result.data });
        } else if (parseInt(result.status) === 403) {
            logout();
        } else {
            console.log(result, 8);
            dispatch({ type: actionTypes.DATALOAD_ERROR, payload: result });
        }
    } catch (error) {
        console.log(error, 5);
        alert("System Error");
    }
};

export const actionGetVFASPClient = (vfaspId) => async (dispatch, getState) => {
    dispatch({ type: actionTypes.CLIENT_DATA_LOADING, payload: true });
    try {
        if (await isValidSession(dispatch) === false) {
            return;
        }

        let result = await client(token).post(`${SERVER_API_URL}/vfaspclient/find`, {
            VfaspID: VFASP_ID,
            AdminID: adminId,
            SearchVfaspID: vfaspId
        });
        dispatch({ type: actionTypes.CLIENT_DATA_LOADING, payload: false });
        if (parseInt(result.status) === 200) {
            dispatch({ type: actionTypes.CLIENT_DATA_SUCCESS, payload: result.data });
        } else if (parseInt(result.status) === 403) {
            logout();
        } else {
            console.log(result, 8);
            dispatch({ type: actionTypes.DATALOAD_ERROR, payload: result });
        }
    } catch (error) {
        console.log(error, 5);
        alert("System Error");
    }
};

export const actionGetIssuerConfig = () => async (dispatch, getState) => {
    dispatch({ type: actionTypes.ISSUERCONFIG_DATA_LOADING, payload: true });
    try {
        if (await isValidSession(dispatch) === false) {
            return;
        }

        let result = await client(token).post(`${SERVER_API_URL}/vfaspclient/issuer/find`, {
            VfaspID: VFASP_ID,
            AdminID: adminId
        });
        dispatch({ type: actionTypes.ISSUERCONFIG_DATA_LOADING, payload: false });
        if (parseInt(result.status) === 200) {
            dispatch({ type: actionTypes.ISSUERCONFIG_DATA_SUCCESS, payload: result.data });
        } else if (parseInt(result.status) === 403) {
            logout();
        } else {
            console.log(result, 8);
            dispatch({ type: actionTypes.DATALOAD_ERROR, payload: result });
        }
    } catch (error) {
        console.log(error, 5);
        alert("System Error");
    }
};

export const actionGetTrancheList = (requestBody) => async (dispatch, getState) => {
    dispatch({ type: actionTypes.TRANCHE_DATA_LOADING, payload: true });
    try {
        if (await isValidSession(dispatch) === false) {
            return;
        }

        requestBody.VfaspID = VFASP_ID;
        requestBody.AdminID = adminId;
        let result = await client(token).post(`${SERVER_API_URL}/tranche/findall`, requestBody);
        dispatch({ type: actionTypes.TRANCHE_DATA_LOADING, payload: false });
        if (parseInt(result.status) === 200) {
            dispatch({ type: actionTypes.TRANCHE_DATA_SUCCESS, payload: result.data });
        } else if (parseInt(result.status) === 403) {
            logout();
        } else {
            console.log(result, 8);
            dispatch({ type: actionTypes.DATALOAD_ERROR, payload: result });
        }
    } catch (error) {
        console.log(error, 5);
        alert("System Error");
    }
};

export const actionGetTranche = (trancheID) => async (dispatch, getState) => {
    dispatch({ type: actionTypes.TRANCHE_DATA_LOADING, payload: true });
    try {
        if (await isValidSession(dispatch) === false) {
            return;
        }

        let result = await client(token).post(`${SERVER_API_URL}/tranche/find`, {
            VfaspID: VFASP_ID,
            AdminID: adminId,
            AUTORECID: trancheID
        });
        dispatch({ type: actionTypes.TRANCHE_DATA_LOADING, payload: false });
        if (parseInt(result.status) === 200) {
            dispatch({ type: actionTypes.TRANCHE_DATA_SUCCESS, payload: result.data });
        } else if (parseInt(result.status) === 403) {
            logout();
        } else {
            console.log(result, 8);
            dispatch({ type: actionTypes.DATALOAD_ERROR, payload: result });
        }
    } catch (error) {
        console.log(error, 5);
        alert("System Error");
    }
};

export const actionGetAgathaConfigurationList = () => async (dispatch, getState) => {
    dispatch({ type: actionTypes.AGATHACONFIG_DATA_LOADING, payload: true });
    try {
        if (await isValidSession(dispatch) === false) {
            return;
        }

        let result = await client(token).post(`${SERVER_API_URL}/agathaconfig/findall`, {
            VfaspID: VFASP_ID,
            AdminID: adminId
        });
        dispatch({ type: actionTypes.AGATHACONFIG_DATA_LOADING, payload: false });
        if (parseInt(result.status) === 200) {
            dispatch({ type: actionTypes.AGATHACONFIG_DATA_SUCCESS, payload: result.data });
        } else if (parseInt(result.status) === 403) {
            logout();
        } else {
            console.log(result, 8);
            dispatch({ type: actionTypes.DATALOAD_ERROR, payload: result });
        }
    } catch (error) {
        console.log(error, 5);
        alert("System Error");
    }
};

export const actionGetVfaspAccessRights = (requestBody) => async (dispatch, getState) => {
    dispatch({ type: actionTypes.VFASPACCESSRIGHTSLIST_DATA_LOADING, payload: true });
    try {
        if (await isValidSession(dispatch) === false) {
            return;
        }

        requestBody.VfaspID = VFASP_ID;
        requestBody.AdminID = adminId;
        let result = await client(token).post(`${SERVER_API_URL}/accessrights/vfasp/findall`, requestBody);
        dispatch({ type: actionTypes.VFASPACCESSRIGHTSLIST_DATA_LOADING, payload: false });
        if (parseInt(result.status) === 200) {
            dispatch({ type: actionTypes.VFASPACCESSRIGHTSLIST_DATA_SUCCESS, payload: result.data });
        } else if (parseInt(result.status) === 403) {
            logout();
        } else {
            console.log(result, 8);
            dispatch({ type: actionTypes.DATALOAD_ERROR, payload: result });
        }
    } catch (error) {
        console.log(error, 5);
        alert("System Error");
    }
};

export const actionGetSupervisorActionLogList = (requestBody) => async (dispatch, getState) => {
    dispatch({ type: actionTypes.SUPERVISORACTIONLIST_DATA_LOADING, payload: true });
    try {
        if (await isValidSession(dispatch) === false) {
            return;
        }

        requestBody.VfaspID = VFASP_ID;
        requestBody.AdminID = adminId;
        let result = await client(token).post(`${SERVER_API_URL}/adminactionlog/findall`, requestBody);
        dispatch({ type: actionTypes.SUPERVISORACTIONLIST_DATA_LOADING, payload: false });
        if (parseInt(result.status) === 200) {
            dispatch({ type: actionTypes.SUPERVISORACTIONLIST_DATA_SUCCESS, payload: result.data });
        } else if (parseInt(result.status) === 403) {
            logout();
        } else {
            console.log(result, 8);
            dispatch({ type: actionTypes.DATALOAD_ERROR, payload: result });
        }
    } catch (error) {
        console.log(error, 5);
        alert("System Error");
    }
};

export const actionGetSupervisorActionLog = (rid) => async (dispatch, getState) => {
    dispatch({ type: actionTypes.SUPERVISORACTION_DATA_LOADING, payload: true });
    try {
        if (await isValidSession(dispatch) === false) {
            return;
        }

        let result = await client(token).post(`${SERVER_API_URL}/adminactionlog/find`, {
            VfaspID: VFASP_ID,
            AdminID: adminId,
            SearchAUTORECID: rid
        });
        dispatch({ type: actionTypes.SUPERVISORACTION_DATA_LOADING, payload: false });
        if (parseInt(result.status) === 200) {
            dispatch({ type: actionTypes.SUPERVISORACTION_DATA_SUCCESS, payload: result.data });
        } else if (parseInt(result.status) === 403) {
            logout();
        } else {
            console.log(result, 8);
            dispatch({ type: actionTypes.DATALOAD_ERROR, payload: result });
        }
    } catch (error) {
        console.log(error, 5);
        alert("System Error");
    }
};

export const actionGetSupervisorAccessRights = (requestBody) => async (dispatch, getState) => {
    dispatch({ type: actionTypes.SUPERVISORACCESSRIGHTSLIST_DATA_LOADING, payload: true });
    try {
        if (await isValidSession(dispatch) === false) {
            return;
        }

        requestBody.VfaspID = VFASP_ID;
        requestBody.AdminID = adminId;
        let result = await client(token).post(`${SERVER_API_URL}/accessrights/findall`, requestBody);
        dispatch({ type: actionTypes.SUPERVISORACCESSRIGHTSLIST_DATA_LOADING, payload: false });
        if (parseInt(result.status) === 200) {
            dispatch({ type: actionTypes.SUPERVISORACCESSRIGHTSLIST_DATA_SUCCESS, payload: result.data });
        } else if (parseInt(result.status) === 403) {
            logout();
        } else {
            console.log(result, 8);
            dispatch({ type: actionTypes.DATALOAD_ERROR, payload: result });
        }
    } catch (error) {
        console.log(error, 5);
        alert("System Error");
    }
};

export const actionGetDefaultAccessRights = (requestBody) => async (dispatch, getState) => {
    dispatch({ type: actionTypes.DEFAULTACCESSRIGHTSLIST_DATA_LOADING, payload: true });
    try {
        if (await isValidSession(dispatch) === false) {
            return;
        }

        requestBody.VfaspID = VFASP_ID;
        requestBody.AdminID = adminId;
        let result = await client(token).post(`${SERVER_API_URL}/accessrights/default/findall`, requestBody);
        dispatch({ type: actionTypes.DEFAULTACCESSRIGHTSLIST_DATA_LOADING, payload: false });
        if (parseInt(result.status) === 200) {
            dispatch({ type: actionTypes.DEFAULTACCESSRIGHTSLIST_DATA_SUCCESS, payload: result.data });
        } else if (parseInt(result.status) === 403) {
            logout();
        } else {
            console.log(result, 8);
            dispatch({ type: actionTypes.DATALOAD_ERROR, payload: result });
        }
    } catch (error) {
        console.log(error, 5);
        alert("System Error");
    }
};

export const actionGetSupervisorLoginList = (requestBody) => async (dispatch, getState) => {
    dispatch({ type: actionTypes.SUPERVISORLOGINLIST_DATA_LOADING, payload: true });
    try {
        if (await isValidSession(dispatch) === false) {
            return;
        }

        requestBody.VfaspID = VFASP_ID;
        requestBody.AdminID = adminId;
        let result = await client(token).post(`${SERVER_API_URL}/supervisorlogin/findall`, requestBody);
        dispatch({ type: actionTypes.SUPERVISORLOGINLIST_DATA_LOADING, payload: false });
        if (parseInt(result.status) === 200) {
            dispatch({ type: actionTypes.SUPERVISORLOGINLIST_DATA_SUCCESS, payload: result.data });
        } else if (parseInt(result.status) === 403) {
            logout();
        } else {
            console.log(result, 8);
            dispatch({ type: actionTypes.DATALOAD_ERROR, payload: result });
        }
    } catch (error) {
        console.log(error, 5);
        alert("System Error");
    }
};

export const actionGetTransactionList = (requestBody) => async (dispatch, getState) => {
    dispatch({ type: actionTypes.TRANSACTIONLIST_DATA_LOADING, payload: true });
    try {
        if (await isValidSession(dispatch) === false) {
            return;
        }

        requestBody.VfaspID = VFASP_ID;
        requestBody.AdminID = adminId;
        let result = await client(token).post(`${SERVER_API_URL}/transaction/findall`, requestBody);
        dispatch({ type: actionTypes.TRANSACTIONLIST_DATA_LOADING, payload: false });
        if (parseInt(result.status) === 200) {
            dispatch({ type: actionTypes.TRANSACTIONLIST_DATA_SUCCESS, payload: result.data });
        } else if (parseInt(result.status) === 403) {
            logout();
        } else {
            console.log(result, 8);
            dispatch({ type: actionTypes.DATALOAD_ERROR, payload: result });
        }
    } catch (error) {
        console.log(error, 5);
        alert("System Error");
    }
};

export const actionGetTransaction = (tid) => async (dispatch, getState) => {
    dispatch({ type: actionTypes.TRANSACTION_DATA_LOADING, payload: true });
    try {
        if (await isValidSession(dispatch) === false) {
            return;
        }

        let result = await client(token).post(`${SERVER_API_URL}/transaction/find`, {
            VfaspID: VFASP_ID,
            AdminID: adminId,
            SearchTransactionID: tid
        });
        dispatch({ type: actionTypes.TRANSACTION_DATA_LOADING, payload: false });
        if (parseInt(result.status) === 200) {
            dispatch({ type: actionTypes.TRANSACTION_DATA_SUCCESS, payload: result.data });
        } else if (parseInt(result.status) === 403) {
            logout();
        } else {
            console.log(result, 8);
            dispatch({ type: actionTypes.DATALOAD_ERROR, payload: result });
        }
    } catch (error) {
        console.log(error, 5);
        alert("System Error");
    }
};

export const actionGetExecutionList = (requestBody) => async (dispatch, getState) => {
    dispatch({ type: actionTypes.EXECUTIONLIST_DATA_LOADING, payload: true });
    try {
        if (await isValidSession(dispatch) === false) {
            return;
        }

        requestBody.VfaspID = VFASP_ID;
        requestBody.AdminID = adminId;
        let result = await client(token).post(`${SERVER_API_URL}/execution/findall`, requestBody);
        dispatch({ type: actionTypes.EXECUTIONLIST_DATA_LOADING, payload: false });
        if (parseInt(result.status) === 200) {
            dispatch({ type: actionTypes.EXECUTIONLIST_DATA_SUCCESS, payload: result.data });
        } else if (parseInt(result.status) === 403) {
            logout();
        } else {
            console.log(result, 8);
            dispatch({ type: actionTypes.DATALOAD_ERROR, payload: result });
        }
    } catch (error) {
        console.log(error, 5);
        alert("System Error");
    }
};

export const actionGetallStats = () => async (dispatch, getState) => {
    dispatch({ type: actionTypes.STATS_DATA_LOADING, payload: true });
    try {
        if (await isValidSession(dispatch) === false) {
            return;
        }

        let result = await client(token).post(`${SERVER_API_URL}/stats/findall`, {
            VfaspID: VFASP_ID,
            AdminID: adminId
        });
        dispatch({ type: actionTypes.STATS_DATA_LOADING, payload: false });
        if (parseInt(result.status) === 200) {
            dispatch({ type: actionTypes.STATS_DATA_SUCCESS, payload: result.data });
        } else if (parseInt(result.status) === 403) {
            logout();
        } else {
            console.log(result, 8);
            dispatch({ type: actionTypes.DATALOAD_ERROR, payload: result });
        }
    } catch (error) {
        console.log(error, 5);
        logout();
    }
};